import { CardContent, CardHeader, Stack, Typography, lighten, styled } from "@mui/material";
import Card from "@mui/material/Card";
import React from "react";

import IContactInfo from "../Types/IContactInfo";

export type OverrideContactType = "Existing Patient" | "New Contact";

export interface IContactInfoDisplayProps {
  contactType: OverrideContactType;
  contactInfo: IContactInfo;
  selected?: boolean;
}

export const classNames = { selected: "contactInfoSelected" };

const ContactInfoHighlightedCard = styled(Card)(({ theme }) => ({
  border: `2px solid ${theme.palette.primary.main}`,
  boxShadow: `0 0 8px ${lighten(theme.palette.primary.main, 0.5)}`,
  backgroundColor: lighten(theme.palette.primary.light, 0.9),
  width: "100%"
}));

const ContactIntoNotHighlightedCard = styled(Card)(() => ({
  width: "100%"
}));

const ContactInfoCardContent: React.FC<Omit<IContactInfoDisplayProps, "selected">> = ({ contactInfo, contactType }) => {
  return (
    <>
      <CardHeader title={contactType} />
      <CardContent>
        <Stack spacing={1}>
          <Stack direction="row" spacing={1}>
            <Typography sx={{ width: "20%", textAlign: "right" }}>Name:</Typography>
            <Typography sx={{ width: "80%", textAlign: "center" }}>
              {`${contactInfo.firstName || ""} ${contactInfo.lastName || ""}`}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography sx={{ width: "20%", textAlign: "right" }}>Phone:</Typography>
            <Typography sx={{ width: "80%", textAlign: "center" }}>{`${contactInfo.phoneNumber || ""}`}</Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography sx={{ width: "20%", textAlign: "right" }}>Email:</Typography>
            <Typography sx={{ width: "80%", textAlign: "center" }}>{`${contactInfo.email || ""}`}</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </>
  );
};

const ContactInfoDisplay: React.FC<IContactInfoDisplayProps> = ({ contactInfo, contactType, selected }) => {
  return selected ? (
    <ContactInfoHighlightedCard className={classNames.selected}>
      <ContactInfoCardContent contactInfo={contactInfo} contactType={contactType} />
    </ContactInfoHighlightedCard>
  ) : (
    <ContactIntoNotHighlightedCard>
      <ContactInfoCardContent contactInfo={contactInfo} contactType={contactType} />
    </ContactIntoNotHighlightedCard>
  );
};

export default ContactInfoDisplay;
